module.exports = {
	"id": "TJ",
	"name": "Tajikistan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.072144,
			"5": 0.021042,
			"6": 0.006012,
			"7": null,
			"8": 0.09018,
			"9": null,
			"10": 0.006012,
			"11": 0.01503,
			"12": 0.072144,
			"13": 0.006012,
			"14": 0.012024,
			"15": 0.096192,
			"16": 0.099198,
			"17": 0.039078,
			"18": 0.276552,
			"19": 0.096192,
			"20": 0.048096,
			"21": 0.117234,
			"22": 0.048096,
			"23": 0.078156,
			"24": 0.19539,
			"25": 0.006012,
			"26": 0.054108,
			"27": 0.063126,
			"28": 0.033066,
			"29": 0.012024,
			"30": 0.009018,
			"31": 0.10521,
			"32": 0.01503,
			"33": 0.018036,
			"34": 0.009018,
			"35": 0.171342,
			"36": 0.054108,
			"37": 0.111222,
			"38": 0.012024,
			"39": 0.186372,
			"40": 0.093186,
			"41": 0.096192,
			"42": 0.009018,
			"43": 0.07515,
			"44": 0.219438,
			"45": 0.144288,
			"46": 0.024048,
			"47": 0.039078,
			"48": 0.051102,
			"49": 1.605204,
			"50": 0.057114,
			"51": 0.237474,
			"52": 0.186372,
			"53": 8.293554,
			"54": 2.395782,
			"55": 0.021042,
			"56": 0.009018,
			"57": null
		},
		"firefox": {
			"2": 0.009018,
			"3": 0.03006,
			"4": 0.009018,
			"5": 0.04509,
			"6": 0.069138,
			"7": 0.009018,
			"8": 0.006012,
			"9": 0.003006,
			"10": null,
			"11": 0.009018,
			"12": 0.009018,
			"13": 0.01503,
			"14": null,
			"15": 0.012024,
			"16": 0.01503,
			"17": 0.006012,
			"18": null,
			"19": 0.01503,
			"20": null,
			"21": 0.006012,
			"22": 0.021042,
			"23": null,
			"24": 0.006012,
			"25": 0.033066,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.01503,
			"31": 0.003006,
			"32": 0.009018,
			"33": 0.003006,
			"34": 0.01503,
			"35": 0.003006,
			"36": 0.039078,
			"37": 0.027054,
			"38": 0.006012,
			"39": 0.039078,
			"40": 0.01503,
			"41": 0.01503,
			"42": 0.006012,
			"43": 0.069138,
			"44": 0.009018,
			"45": 0.048096,
			"46": 0.102204,
			"47": 0.294588,
			"48": 0.168336,
			"49": 1.641276,
			"50": 0.009018,
			"51": null,
			"52": null,
			"3.5": 0.036072,
			"3.6": 0.763524
		},
		"opera": {
			"9": null,
			"11": 0.01503,
			"12": 0.048096,
			"15": 0.003006,
			"16": 0.009018,
			"17": 0.009018,
			"18": 0.018036,
			"19": 0.012024,
			"20": 0.009018,
			"21": 0.012024,
			"22": 0.006012,
			"23": 0.06012,
			"24": null,
			"25": 0.039078,
			"26": 0.003006,
			"27": 0.138276,
			"28": 0.012024,
			"29": 0.006012,
			"30": 0.036072,
			"31": null,
			"32": 0.01503,
			"33": 0.009018,
			"34": 0.018036,
			"35": 0.018036,
			"36": 0.192384,
			"37": 0.06012,
			"38": 0.027054,
			"39": 0.027054,
			"40": 1.031058,
			"41": 0.153306,
			"42": 0.009018,
			"43": null,
			"9.5-9.6": 0.16533,
			"10.0-10.1": 0,
			"10.5": 0.012024,
			"10.6": 0.021042,
			"11.1": 0.01503,
			"11.5": 0.018036,
			"11.6": 0.036072,
			"12.1": 1.21743
		},
		"safari": {
			"0": null,
			"4": 0.03006,
			"5": 0.162324,
			"6": 0.01503,
			"7": 0.009018,
			"8": 0.048096,
			"9": 0.033066,
			"10": 0.102204,
			"3.1": null,
			"3.2": null,
			"5.1": 0.027054,
			"6.1": null,
			"7.1": null,
			"9.1": 0.06012
		},
		"ios_saf": {
			"8": 0,
			"10": 2.29458904246,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.061836519567,
			"8.1-8.4": 0.114240349709,
			"9.0-9.2": 0.0544999833472,
			"9.3": 0.831474104913
		},
		"android": {
			"3": 0,
			"4": 0.112701139535,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0140876424419,
			"4.1": 0.406529110465,
			"4.2-4.3": 1.01632277616,
			"4.4": 2.33049856395,
			"4.4.3-4.4.4": 2.35062376744
		},
		"ie": {
			"6": 0.0061658503937,
			"7": 0.0154146259843,
			"8": 0.419277826772,
			"9": 0.0924877559055,
			"10": 0.212721838583,
			"11": 0.820058102362,
			"5.5": null
		},
		"op_mob": {
			"0": 2.29746652696,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0638185146379
		},
		"edge": {
			"12": 0.033066,
			"13": 0.213426,
			"14": 0.087174
		},
		"ie_mob": {
			"10": 0.157194760563,
			"11": 0.640007239437
		},
		"bb": {
			"7": 0.0034965,
			"10": null
		},
		"samsung": {
			"0": 3.783213
		},
		"and_uc": {
			"0": 7.006986
		},
		"op_mini": {
			"0": 30.9533669584
		},
		"and_chr": {
			"0": 15.487101
		},
		"and_ff": {
			"0": null
		}
	},
	"total": 95.3236395
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TJ.json
 ** module id = 659
 ** module chunks = 0
 **/